export const CmsTypes = {
  TermsAndConditions: 1,
  CookiesPolices: 2,
  PrivacyPolicy: 3,
  FAQs: 4,
  Blog: 5,
  SuccessStories: 6,
  News: 7,
};

export const CmsState = {
  Published: 1,
  Unpublished: 2,
};

export const CmsId = {
  TermsAndConditions: 1,
  CookiesPolices: 2,
  PrivacyPolicy: 3,
  FAQs: 4,
};
